(function () {
  'use strict';

  // In-app browsers (Google app, Instagram, Chrome iOS) shrink the viewport
  // when the keyboard opens. Many drawers read that resize as "close".
  // This suppresses resize-driven closing only while the search field is in use.

  var GUARD_MS = 1200;
  var guardUntil = 0;

  function guarding() { return Date.now() < guardUntil; }
  function openGuard() { guardUntil = Date.now() + GUARD_MS; }

  ['resize', 'orientationchange'].forEach(function (type) {
    window.addEventListener(type, function (e) {
      if (guarding()) e.stopImmediatePropagation();
    }, true);
  });

  if (window.visualViewport) {
    ['resize', 'scroll'].forEach(function (type) {
      window.visualViewport.addEventListener(type, function (e) {
        if (guarding()) e.stopImmediatePropagation();
      }, true);
    });
  }

  var INPUT_SEL = 'input[type="search"], input[name="q"]';

  function isDrawerSearch(el) {
    if (!el || !el.closest || !el.matches(INPUT_SEL)) return false;
    return !!(
      el.closest('[class*="drawer"]') ||
      el.closest('[class*="menu"]') ||
      el.closest('nav-drawer') ||
      el.closest('[class*="header"]')
    );
  }

  function stop(e) { e.stopPropagation(); }

  function wire(el) {
    if (!el || el.__hdSearchWired) return false;
    el.__hdSearchWired = true;

    el.removeAttribute('readonly');
    el.removeAttribute('disabled');
    el.style.pointerEvents = 'auto';

    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
      el.addEventListener(type, function (e) { openGuard(); stop(e); }, true);
    });

    el.addEventListener('click', function (e) {
      openGuard();
      stop(e);
      try { el.focus({ preventScroll: true }); } catch (err) {
        try { el.focus(); } catch (err2) {}
      }
    }, true);

    el.addEventListener('focus', function () {
      openGuard();
      var iv = setInterval(function () {
        if (document.activeElement === el) { openGuard(); }
        else { clearInterval(iv); }
      }, 400);
    }, true);

    return true;
  }

  function scan() {
    var inputs = document.querySelectorAll(INPUT_SEL);
    var wiredAny = false;
    for (var i = 0; i < inputs.length; i++) {
      if (isDrawerSearch(inputs[i])) {
        if (wire(inputs[i])) wiredAny = true;
      }
    }
    return wiredAny;
  }

  function safeScan() {
    try { return scan(); } catch (e) { console.warn('HD search fix:', e); return false; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeScan);
  } else {
    safeScan();
  }
  window.addEventListener('load', safeScan);

  var delays = [200, 600, 1500, 3000];
  for (var d = 0; d < delays.length; d++) setTimeout(safeScan, delays[d]);

  // The drawer is usually built the first time it is opened, so re-scan on
  // taps only. No MutationObserver: watching the whole document caused
  // repeated work while scrolling as lazy images loaded.
  document.addEventListener('click', function () { setTimeout(safeScan, 80); }, true);
  document.addEventListener('shopify:section:load', safeScan);
})();
